import { useEffect } from "react";

import { css } from "@compiled/react";

import { useFitPriceTextIntoPlanCard } from "../hooks/use-fit-price-text-into-plan-card";

export type HighestDisplayPriceProps = {
    readonly cardWidth: number;
    readonly onFontSizeHandler: (fontSize: string) => void;
};

const highestDisplayPriceStyled = css({
    height: "60px",
    lineHeight: "54px",
    margin: 0,
    fontFamily: "Charlie Display",
    fontWeight: 500,
    verticalAlign: "center",
    textAlign: "center",
    border: "2px solid red",
    position: "absolute",
    insetInlineStart: "-9999999px",
    insetBlockStart: "-9999999px"
});
export const HighestDisplayPriceFontSize = ({
    cardWidth,
    onFontSizeHandler
}: HighestDisplayPriceProps) => {
    const { ref, fontSize, highestDisplayPrice } =
        useFitPriceTextIntoPlanCard();

    useEffect(() => {
        onFontSizeHandler(fontSize);
    }, [fontSize]);

    return (
        <div style={{ fontSize: "54px" }}>
            <div
                ref={ref}
                css={[
                    highestDisplayPriceStyled,
                    css({
                        "width": "75%",
                        "fontSize": fontSize,
                        "@media (min-width: 1024px)": {
                            width: `${cardWidth}px`
                        }
                    })
                ]}
            >
                {highestDisplayPrice}
            </div>
        </div>
    );
};
